import React from "react";
import { NavLink } from "react-router-dom";
import ListItem from "@mui/material/ListItem";

const NavLinkMui = React.forwardRef(({ end, children, ...props }, ref) => {
    return (
        <ListItem
            button
            component={NavLink}
            end={end}
            ref={ref}
            {...props}
        >
            {children}
        </ListItem>
    );
});

export default NavLinkMui;
